import type { TeamDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getTeamDetails(teamId: string): Promise<TeamDetailed> {
  return requestApiJsonOrThrow<TeamDetailed>(`admin/teams/${teamId}`)
}

export const teamDetailsQuery = (teamId: string) => ({
  queryKey: ['team', teamId],
  queryFn: () => getTeamDetails(teamId),
})
